import React from "react";
import "./ServicesSection.css";
import bgImage from "../Assets/bg-image.png"; // replace with your background image
import service1 from '../Assets/service1.png';
import service2 from '../Assets/service2.png';
import service3 from '../Assets/service3.png';
import service4 from '../Assets/service4.png';
import service5 from '../Assets/service5.png';  
import service6 from '../Assets/service6.png';
import service7 from '../Assets/service7.png';
import service8 from '../Assets/service8.png';
import service9 from '../Assets/service9.jpg';
import service10 from '../Assets/service10.jpg';

const services = [
  {
    title: "University/Country/Course selection",
    desc: "Guidance from expert study abroad consultants to choose the best-fit university, country, and academic program. We are trusted abroad education consultants helping students make the right global decisions.",
    img: service1
  },
  {
    title: "Career Counselling & Profile Evaluation",
    desc: "Personalized assessment by experienced overseas study consultants to match your profile with the right study abroad programs and career opportunities abroad.",
    img: service2
  },
  {
    title: "Test Preparation - IELTS / GRE/ GMAT / TOEFL / PTE / SAT",
    desc: "Comprehensive coaching support is provided by leading global education consultants in Bangalore, helping students achieve high scores for top study abroad programs.",
    img: service3
  },
  {
    title: "Application Submission",
    desc: "End-to-end application support from expert study abroad consultants, ensuring accurate and successful submissions to top international universities.",
    img: service4
  },
  {
    title: "Visa Counseling",
    desc: "Professional visa guidance from trusted abroad education consultants with a high success rate for student visa approvals.",
    img: service5
  },
  {
    title: "Pre Departure Briefing",
    desc: "Complete pre-departure support by experienced overseas study consultants, preparing you for a smooth transition to your study destination.",
    img:service6
  },
  {
    title: "Post Arrival Assistance & Services",
    desc: "We provide continued support as leading global education consultants in Bangalore, ensuring students settle comfortably abroad.",
    img: service7
  },
  {
    title: "Assistance in Accommodation",
    desc: "Helping students find safe and affordable housing through our expert study abroad consultants and global support network.",
    img: service8
  },
   {
    title: "Education Loan Assistance",
    desc: "As experienced abroad education consultants, we understand that financing your education is a crucial step in your journey. That’s why we provide complete support in securing education loans tailored for students enrolling in top study abroad programs.",
    img: service9
  },
   {
    title: "Flight Ticket Booking, Forex and Insurance",
    desc: "Our abroad education consultants ensure a smooth journey for students in study abroad programs. We handle travel, forex, and insurance for a hassle-free experience.",
    img: service10
  },
];

const ServicesSection = () => {
  return (
    <section
      className="services-section text-white"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="container text-center py-5">
        <h2 className="mb-3 fw-bold">Our Services</h2>
        <p className="mb-5">
          We provide extensive academic guidance for UG and PG programs,
          including MS, MBA, MBBS and Nursing Courses <br/> through our unparalleled 'ground and cloud'
          system.
        </p>
        <div className="row g-4  justify-content-center">
          {services.map((service, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <div className="service-card p-3 h-100">
                <img
                  src={service.img}
                  alt={service.title}
                  className="img-fluid rounded mb-3"
                />
                <h6 className="fw-bold">{service.title}</h6>
                <p className="small">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
